import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useSlots, computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'TabItem',
  props: {
  /**选中的值 */
  val: {     
    type: String,
    default: ''
  }
},
  emits: ['choosed'],
  setup(__props, { emit }) {

const props = __props;


const slot = useSlots()

const content = computed(() => {
  return slot.default()?.[0].children
})

function onClick() {
  emit('choosed', slot.default()?.[0].children)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tabItem", props.val == content.value ? 'choosed' : '']),
    onClick: onClick
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})